import { Box } from "@mui/material";
import MapDataTable from "../../../components/MapDataTable/TemplateDriven/MapDataTable";
import CNCTableWrapper from "../../../components/MapDataTable/Free-Form/CNCTableWrapper";
import TableSkeleton from "../../../components/Skeletons/TableSkeleton";
import QCTable from "../../../components/MapDataTable/QCTable/QCTable";
import MapFooter from "../../../components/Footer/MapFooter";
import { createRef, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  clearApiStatus,
  clearQcSaveAPiStatus,
} from "../../../redux/pre_processor/actions";
import CustomizedSnackbars from "../../../components/Snackbars/CustomizedSnackbars";
import ProgressBar from "../../../components/ProgressBar";
import { preProRoutes } from "../../../routes/routeConstants";

const MapDataTableParent = ({
  showParameterTable,
  is_template_uploaded,
  selectedFile,
  selectedArea,
  parametersData,
  //   ref,
  role,
  reProcess,
  isDataRejectedByProcessor,
  isDataRejectedByValidator,
  resetPdfHeighlights,
  entireBatchRejectedByPro,
  showContextMenu,
  resestSelectedArea,
  areaIndex,
  columnsCount,
  isDisableOnChangeInput,
  isDisableOnBlur,
  //   qcTemplateData,
  isDisableMultipageMappingLable,
  isShowReject,
  isPrevious,
  disableSaveAndNext,
  projectType,
  props,
  //footer
}) => {
  const child = createRef();
  const qcChild = createRef();

  // const qcParametersData = useSelector(
  //   (state) => state?.prePro?.qcParametersData || []
  // );
  const qcSaveAPiStatus = useSelector(
    (state) => state?.prePro?.qcSaveAPiStatus
  );
  const apiStatus = useSelector((state) => state.prePro?.apiStatus);

  const [action, setAction] = useState("");
  const [loader, setLoader] = useState(false);
  const [success, setSuccess] = useState(false);
  const [err, setErr] = useState(false);
  const [message, setMessage] = useState("");

  // const qcTemplateData = useSelector(
  //   (state) => state?.prePro?.coorData?.qc_mappingDetails?.templateData || []
  // );

  const dispatch = useDispatch();

  const handleSuccess = (next, message, navigateTo) => {
    setLoader(false);
    setSuccess(true);
    setErr(false);
    setMessage(message);

    if (next) {
      setTimeout(() => {
        // setSuccess(false);
        // setMessage("");
        props.navigate(navigateTo);
      }, 2000);
      // dispatch(clearApiStatus());
    }
    // dispatch(clearApiStatus());
  };

  const handleError = (errorMessage) => {
    setLoader(false);
    setSuccess(false);
    setErr(true);
    setMessage(errorMessage);
    // dispatch(clearApiStatus()); // Cleanup after success
  };

  const handleLoader = (isLoading) => setLoader(isLoading);

  useEffect(() => {
    const { loader, apiSuccess, apiError, next, message } = apiStatus || {};

    if (loader) {
      handleLoader(true);
    }

    if (loader === false && apiSuccess) {
      // handleSuccess(next, message, "/pre-processor-dashboard");
      handleSuccess(next, message, `/${preProRoutes.preProDashboard}`);
      dispatch(clearApiStatus());
    }

    if (loader === false && apiError) {
      handleError(message);
      dispatch(clearApiStatus());
    }
  }, [apiStatus]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (child.current) {
        // Ensure child is mounted before calling
        // onClickFooterAction("save", true);
      }
    }, 120000); // 1 minute

    return () => clearInterval(interval); // Clean up the interval when component unmounts
  }, [child]); // Depend on `child` to ensure updates when it's initialized

  // useEffect(() => {
  //   if (qcSaveAPiStatus?.loader) {
  //     setLoader(true);
  //   }

  //   // calls after project type both and qc save success
  //   if (
  //     projectType === "both" &&
  //     qcSaveAPiStatus?.apiSuccess &&
  //     qcSaveAPiStatus?.next
  //   ) {
  //     child.current.mapData(action);
  //     dispatch(clearQcSaveAPiStatus());
  //   }

  //   if (
  //     qcSaveAPiStatus?.apiError &&
  //     !qcSaveAPiStatus?.loader &&
  //     qcSaveAPiStatus?.message !== ""
  //   ) {
  //     setMessage(qcSaveAPiStatus?.message);
  //     setErr(true);
  //     dispatch(clearQcSaveAPiStatus());
  //   }

  //   if (
  //     projectType === "qc_extraction" &&
  //     qcSaveAPiStatus?.apiSuccess &&
  //     qcSaveAPiStatus?.next
  //   ) {
  //     setLoader(false);
  //     setSuccess(true);
  //     setErr(false);
  //     setMessage(message);

  //     setTimeout(() => {
  //       // setSuccess(false);
  //       // setMessage("");
  //       props.navigate("/pre-processor-dashboard");
  //     }, 2000);
  //     dispatch(clearQcSaveAPiStatus());
  //   }

  //   if (
  //     projectType === "qc_extraction" &&
  //     qcSaveAPiStatus?.apiSuccess &&
  //     qcSaveAPiStatus?.next === false
  //   ) {
  //     setLoader(false);
  //     setSuccess(true);
  //     setErr(false);
  //     setMessage(message);

  //     dispatch(clearQcSaveAPiStatus());
  //   }
  // }, [qcSaveAPiStatus]);

  // QC Save API handler useEffect
  useEffect(() => {
    const { loader, apiSuccess, apiError, next, message, autosave } =
      qcSaveAPiStatus || {};

    if (loader) {
      handleLoader(true);
    }

    // Handle project type-specific logic
    if (projectType === "both" && apiSuccess) {
      child.current.mapData(action, null, null, null, autosave);
      dispatch(clearQcSaveAPiStatus());
    } else if (apiError && !loader && message) {
      handleError(message);
      dispatch(clearQcSaveAPiStatus());
    } else if (projectType === "qc_extraction" && apiSuccess && next) {
      // handleSuccess(next, message, "/pre-processor-dashboard");
      handleSuccess(next, message, `/${preProRoutes.preProDashboard}`);
      dispatch(clearQcSaveAPiStatus());
    } else if (
      projectType === "qc_extraction" &&
      apiSuccess &&
      !next &&
      autosave !== true
    ) {
      handleSuccess(next, message);

      dispatch(clearQcSaveAPiStatus());
    }
  }, [qcSaveAPiStatus, projectType]);

  const callQcMapData = (action, autoSave, projectType) => {
    const next =
      projectType === "both" && autoSave === false
        ? true
        : action === "save"
          ? false
          : true;
    if (qcChild.current) {
      qcChild.current.mapData2(action, next, autoSave);
    }

    // dispatch(
    //   qcMapData({
    //     parametersData: qcParametersData,
    //     projectId: localStorage.projectId,
    //     // next: action === "save" ? false : true,
    //     next:
    //       projectType === "both" && autoSave === false
    //         ? true
    //         : action === "save"
    //         ? false
    //         : true,
    //     autosave: autoSave,
    //     isUpdateParameters: false,
    //     logs: [],
    //   })
    // );
  };

  const onClickFooterAction = (action, autoSave = false) => {
    setAction(action); // for useEffect call
    // this.setState({
    //   action: action,
    // });

    if (action === "cancel") {
      // props.navigate("/pre-processor-dashboard");
      props.navigate(`/${preProRoutes.preProDashboard}`)  
    } else if (action === "previous") {
      // props.navigate("/upload-template-data");
      props.navigate(`/${preProRoutes.uploadTemplateData}`) 
    } // Check if `this.child` exists and call its method
    else if (projectType === "parameter_extraction" && child.current) {
      child.current.mapData(action, null, null, null, autoSave);
    }
    // else {
    //   console.error("child is null or not yet rendered");
    // }

    // Check if `this.qcChild` exists and call its method
    // if (this.qcChild.current) {
    //   this.qcChild.current.mapData2(action);
    // } else {
    //   console.error("qcChild is null or not yet rendered");
    // }
    else if (projectType === "qc_extraction") {
      callQcMapData(action, autoSave, projectType);
    } else if (projectType === "both") {
      callQcMapData(action, autoSave, projectType);
    }
  };

  return (
    <Box>
      {
        // showParameterTable === true ? (
        // <Box
        //   sx={{
        //     display: this.state.showParameterTable
        //       ? "block"
        //       : "none",
        //   }}
        // >
        // {
        is_template_uploaded === true ? (
          <MapDataTable
            selectedFile={selectedFile}
            selectedArea={selectedArea}
            parametersData={parametersData}
            ref={child}
            role={role}
            reProcess={reProcess}
            isDataRejectedByProcessor={isDataRejectedByProcessor}
            isDataRejectedByValidator={isDataRejectedByValidator}
            // isFullView={this?.props?.isFullView}
            resetPdfHeighlights={resetPdfHeighlights}
            entireBatchRejectedByPro={entireBatchRejectedByPro}
            showContextMenu={showContextMenu}
            resestSelectedArea={resestSelectedArea}
            showParameterTable={showParameterTable}
          />
        ) : is_template_uploaded === false ? (
          <CNCTableWrapper
            selectedFile={selectedFile}
            selectedArea={selectedArea}
            areaIndex={areaIndex}
            ref={child}
            role={role}
            parametersData={parametersData}
            columnsCount={columnsCount}
            reProcess={reProcess}
            isDataRejectedByProcessor={isDataRejectedByProcessor}
            isDataRejectedByValidator={isDataRejectedByValidator}
            // isFullView={this?.props?.isFullView}
            showContextMenu={showContextMenu}
            isDisableOnChangeInput={isDisableOnChangeInput}
            isDisableOnBlur={isDisableOnBlur}
            resetPdfHeighlights={resetPdfHeighlights}
            entireBatchRejectedByPro={entireBatchRejectedByPro}
            resestSelectedArea={resestSelectedArea}
            showParameterTable={showParameterTable}
          />
        ) : (
          <TableSkeleton />
        )
      }
      {/* // ) : ( */}
      {/* // </Box> */}
      {/* // <Box */}
      {/* //   sx={{ */}
      {/* //     display: this.state.showParameterTable
        //       ? "none"
        //       : "block",
        //   }}
        // > */}
      <QCTable
        role={role}
        selectedFile={selectedFile}
        // qcTemplateData={qcTemplateData}
        showParameterTable={showParameterTable}
        ref={qcChild}
        // isFullView={this?.props?.isFullView}
      />
      {/* // )} */}

      {loader ? <ProgressBar /> : ""}

      {success && (
        <CustomizedSnackbars
          severity="success"
          state={success}
          text={message}
          handleClose={() => setSuccess(false)}
        />
      )}

      {err && (
        <CustomizedSnackbars
          severity="error"
          state={err}
          text={message}
          handleClose={() => setErr(false)}
        />
      )}

      <Box sx={{ marginTop: "2px !important" }}>
        <MapFooter
          // pdfCount={this.props?.coorData.length}
          isDisableMultipageMappingLable={true}
          onClickFooterAction={onClickFooterAction}
          isShowReject={false}
          isPrevious={true}
          disableSaveAndNext={
            projectType === "both" && showParameterTable === false
          }
          role={role}
        />
      </Box>
      {/* <MapFooter
        // pdfCount={props?.coorData.length}
        isDisableMultipageMappingLable={isDisableMultipageMappingLable}
        onClickFooterAction={onClickFooterAction}
        isShowReject={isShowReject}
        isPrevious={isPrevious}
        disableSaveAndNext={disableSaveAndNext}
      /> */}
    </Box>
  );
};

export default MapDataTableParent;
